export const inIframe = (): boolean => {
  try {
    return window.self !== window.top
  } catch (error) {
    return true
  }
}

export const isMessageEvent = (event: MessageEvent, type: string): boolean => {
  return event?.data?.type === type
}
